import { gql } from '@apollo/client';

export const TelnyxThrottlingQuery = gql`
  query TelnyxThrottling($campaignId: ID!) {
    telnyxThrottling(campaignId: $campaignId) {
      maxBucketSize
      windowInSeconds
    }
  }
`;

export const UpdateTelnyxThrottlingMutation = gql`
  mutation UpdateTelnyxThrottling($campaignId: ID!, $maxBucketSize: Int!, $windowInSeconds: Int!) {
    updateTelnyxThrottling(
      campaignId: $campaignId
      maxBucketSize: $maxBucketSize
      windowInSeconds: $windowInSeconds
    )
  }
`;
